const NAImg = {
    pc: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711007720117/KV-PCjpg.jpg',
    h5: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711007768584/KV-MOjpg.jpg',
};

const euImg = {
    pc: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711007884977/EU-KV-PCjpg.jpg',
    h5: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711007898107/EU-KV-MOjpg.jpg',
};

const ukImg = {
    pc: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1710764492407/pc.jpg',
    h5: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1710764515105/h5.jpg',
};

const krImg = {
    pc: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711357407376/kr-KV-PCjpg.jpg',
    h5: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711357446972/kr-KV-MOjpg.jpg',
};

const zaImg = {
    pc: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711595243435/za-KV.jpg',
    h5: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711595345417/za-KV.jpg',
};

const auImg = {
    pc: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1712054500475/UK-KV-PC.jpg',
    h5: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1712054568709/UK-KV-MO.jpg',
};

const jpImg = {
    pc: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1712730271464/jp-KV-PC.jpg',
    h5: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1712730271464/jp-KV-PC.jpg',
};

export const BannerImgAll: Record<string, { pc: string; h5: string }> = {
    us: NAImg,
    uk: ukImg,
    eu: euImg,
    de: euImg,
    fr: euImg,
    it: euImg,
    es: euImg,
    kr: krImg,
    za: zaImg,
    au: auImg,
    jp: jpImg,
};
